import { useTranslation } from 'next-i18next'

import { useRouter } from 'next/router'

import useActivityNavigation from '~/statistics/hooks/useActivityNavigation'
import LevelListItem from '~/math-vault/components/LevelList/LevelListItem'
import { MathVaultLevelStat } from '~/redux/apis/user-stats-api'
import SVGImage from '~/components/Image/SVGImage'
import ROUTES from '~/shared/constants/routes.const'

interface Props {
  activityPath: string
  roomColor: string
  level: MathVaultLevelStat
  locale: string | undefined
}

export default function MathVaultLevels({
  activityPath,
  roomColor = 'orange',
  level,
  locale,
}: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const router = useRouter()
  const isFamilyView = router.asPath.includes(ROUTES.FAMILY_ADMIN_PANEL)
  const { completedActivitiesCount, levelNo, totalActivitiesCount } = level
  const { onContinueActivity } = useActivityNavigation(locale)
  const levelFilled = (completedActivitiesCount / totalActivitiesCount) * 100 || 0

  return (
    <div className="flex justify-between items-center pt-3">
      <div className="flex items-center space-x-4">
        <LevelListItem
          filled={levelFilled}
          href=""
          isActive={false}
          isLoading={false}
          key={levelNo}
          label={levelNo}
          notClickable
          roomColor={roomColor}
        />
        <p>
          {t('level')} {level.levelNo}
        </p>
      </div>
      <p className={`pr-7 ${isFamilyView ? '' : 'md:pr-14'}`}>
        {completedActivitiesCount}/{totalActivitiesCount}
      </p>
      {!isFamilyView && (
        <div className="flex space-x-2">
          <SVGImage
            alt={t('alt_texts.go')}
            className="cursor-pointer"
            onClick={() => onContinueActivity(activityPath)}
            srcKey="scoreboard/continue-icon.svg"
          />
        </div>
      )}
    </div>
  )
}
